import { FETCH_SCHEDULE_TYPE, FETCH_SCHEDULE_TYPE_SUCCESS, FETCH_SCHEDULE_TYPE_FAILURE, CLEAR_SCHEDULE_TYPE } from '../actions';

const initialState = {
  scheduletype: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_SCHEDULE_TYPE:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_SCHEDULE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        scheduletype: action.data
      };
    case FETCH_SCHEDULE_TYPE_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        scheduletype: {}
      };
    case CLEAR_SCHEDULE_TYPE:
      return initialState;
    default:
      return state;
  }
}